// extracted by mini-css-extract-plugin
module.exports = {"rowContainer":"_3VJ24XnjdTPOcu7qh7ctzA","rowTitle":"_2izDRaeGmh-uYkuglzl3mZ","boxTable":"_1_LVPrmMwrPwIdbvVxQHN","checkbox":"WXABa9EUPzgC3ncji2B79"};